export const isGroupSelected = (groupOption, selectedByType) => {
    if (!groupOption.isGroup || !groupOption.items?.length) return false;
    return groupOption.items.every(item => selectedByType[item.type]?.has(item.id));
};

export const getOptionItems = (option) => {
    if (option.isGroup && Array.isArray(option.items) && option.items.length) {
        return option.items;
    }
    return [{type: option.type, id: option.id}];
};